import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "components.SearchForm.title",
    defaultMessage: "Search"
  },
  inputPlaceholder: {
    id: "components.SearchForm.inputPlaceholder",
    defaultMessage: "Search cameras and views"
  },
  submit: {
    id: "components.SearchForm.submit",
    defaultMessage: "Go"
  }
});
